module.exports = __webpack_public_path__ + "src/assets/img/9_3art_2part.d1765c3f.jpg";